import { render, staticRenderFns } from "./OrderGoods.vue?vue&type=template&id=e7a0ee24&scoped=true"
import script from "./OrderGoods.vue?vue&type=script&lang=js"
export * from "./OrderGoods.vue?vue&type=script&lang=js"
import style0 from "./OrderGoods.vue?vue&type=style&index=0&id=e7a0ee24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a0ee24",
  null
  
)

export default component.exports